import React                                            from 'react';
import {Button}                                         from '@sirius/ui-lib/src/blocks/Controls'
import {block}                                          from '../block';
import {UiSchemaEntry, DataCellType, ColumnCellType}    from '../@types';

const DataCell:React.FC<DataCellType> = ({row, onActionButton, column}) => {

    const handleAction = (e: React.MouseEvent) => {
        e.stopPropagation();
        onActionButton(row);
    };

    return <Button mode      = {'primary'}
                   size      = {'xs'}
                   icon      = {row[column.name].button.icon || ''}
                   className = {block.el('datacell-name')}
                   onAction  = {handleAction}
    >
        {row[column.name].button.data || ''}
    </Button>;
};

const ColumnCell:React.FC<ColumnCellType> = () => null;

const ActionButtonCell: UiSchemaEntry = {
    DataCell, ColumnCell
}

export {ActionButtonCell};
